import { defineComponent as _defineComponent } from 'vue';
import { validate } from '@/utils';
import { ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'status',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: val => {
        return ['xs', 'sm', 'md', 'lg'].includes(val.toLowerCase());
      }
    },
    text: {
      type: [String, Number],
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    clickable: {
      type: Boolean,
      default: false
    },
    canSelect: {
      type: Boolean,
      default: true
    },
    styleObj: {
      type: Object,
      default: () => ({})
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    icon: {
      type: String,
      default: ''
    },
    state: {
      type: String,
      default: 'default'
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: ''
    },
    tooltipPosition: {
      type: String,
      default: 'none'
    },
    tooltipText: {
      type: String,
      default: ''
    },
    appendedText: {
      type: String,
      default: ''
    },
    fontAwesomeIcon: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: String,
      default: 'sm'
    }
  },
  emits: ['selected'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const selected = ref(false);
    const toggleSelected = () => {
      selected.value = !selected.value;
      emit('selected', selected.value);
    };
    const getFontSize = size => {
      if (size === 'xs') return 3;
      if (size === 'sm') return 3;
      if (size === 'md') return 2;
      if (size === 'lg') return 1;
    };
    const {
      isEllipses
    } = validate;
    return {
      __sfc: true,
      selected,
      props,
      emit,
      toggleSelected,
      getFontSize,
      isEllipses
    };
  }
});